import React from 'react';
import PropTypes from 'prop-types';
import * as firebase from "firebase/app";
import 'firebase/firebase-functions';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';

import Fab from '@material-ui/core/Fab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import CallIcon from '@material-ui/icons/Call';


import {
  isMobileOnly
} from "react-device-detect";


function chunkify(a, n) {
  if (a.length === 0) {
    return [[], []]
  }

  if (a.length === 1) {
    return [a, []]
  }
  if (n < 2)
    return [a];

  var len = a.length,
    out = [],
    i = 0,
    size;

  if (len % n === 0) {
    size = Math.floor(len / n);
    while (i < len) {
      out.push(a.slice(i, i += size));
    }
  }

  while (i < len) {
    size = Math.ceil((len - i) / n--);
    out.push(a.slice(i, i += size));
  }

  return out;
}


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const styles = {
  root: {
    backgroundColor: '#fff',
    width: '100vw',
    marginTop: '2%',
    flexGrow: 1,
  },
  tablePaper: {
    width: '100vw',
    marginTop: '0%',
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  typography: {
    marginTop: '2%'
  }
};

class Workspace extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      orders: [],
      open: false,
      selectedOrderItems: [],
      selectedOrder: {},
      profile: {},
      openDeliveryConfirm: false,
      code: '',
      codeError: false,
      riskyDialogOpen: false,
      mainLoader: true,
      paymentPendingOrders: [],
      paidPendingOrders: [],
      awaitingPackageOrders: [],
      awaitingDispatchedOrders: [],
      dispatchedOrders: [],
    }
  }

  componentWillMount() {
    const currentUser = firebase.auth().currentUser;

    firebase.firestore().collection('orders').orderBy('created_at').onSnapshot(orderSnapshots => {
      const orders = orderSnapshots.docs.map(order => {
        const rowData = order.data();
        return Object.assign({ uid: order.id }, rowData);
      });

      const paymentPendingOrders = orders.filter(x => x.status === 'Payment_Pending').reverse();
      const paidPendingOrders = orders.filter(x => x.status === 'Paid_Pending');
      const awaitingPackageOrders = orders.filter(x => x.status === 'Awaiting_Packaging' && x.packer_uid === currentUser.uid);
      const awaitingDispatchedOrders = orders.filter(x => x.status === 'Awaiting_Dispatch' && x.packer_uid === currentUser.uid);
      const dispatchedOrders = orders.filter(x => x.status === 'Dispatched' && x.packer_uid === currentUser.uid);
      this.setState({
        orders,
        loader: false,
        mainLoader: false,
        paymentPendingOrders,
        paidPendingOrders,
        awaitingPackageOrders,
        awaitingDispatchedOrders,
        dispatchedOrders
      });

    });

    firebase.firestore().collection('profile').doc(currentUser.uid).get().then(profileSnapshot => {
      this.setState({ profile: profileSnapshot.data() })
    });
  }

  handleDeliveryConfirmClose = () => {
    this.setState({ openDeliveryConfirm: false, selectedOrder: {}, code: '', codeError: false });
  }

  handleDeliveryConfirmOpen = (order) => {
    console.log("order id => ", order.uid)
    this.setState({ openDeliveryConfirm: true, selectedOrder: order })
  }

  handleRiskyDialogClose = () => {
    this.setState({ riskyDialogOpen: false });
  }


  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  isAdminOrSupervisor() {
    const { profile } = this.state;
    if (profile.roles) {
      return profile.roles.includes('administrator') || profile.roles.includes('supervisor');
    }
    return false
  }

  isAdmin() {
    const { profile } = this.state;
    if (profile.roles) {
      return profile.roles.includes('administrator');
    }
    return false
  }

  pickOrder(order) {
    const orderId = order.uid
    const currentUser = firebase.auth().currentUser;
    const profile = this.state.profile;

    if (order.risky) {
      this.setState({ riskyDialogOpen: true });
      return;
    }

    if (!order.purchase_order_active) {
      this.setState({ noPurchaseOrderDialog: true });
      console.log(order);
      return;
    }

    const pickOrderForPackaging = firebase.functions().httpsCallable('pickOrderForPackaging');
    this.setState({ mainLoader: true })
    pickOrderForPackaging({ order, profile }).then(value => {
      this.setState({ pickOrderSuccess: true, mainLoader: false });
    }).catch(reason => {
      this.setState({ pickOrderFailure: true, mainLoader: false });
      console.log(reason);
    });
  }

  dispatchOrder(orderId) {
    firebase.firestore().collection('orders').doc(orderId)
      .update({ status: 'Dispatched', dispacthedAt: new Date().getTime() });
  }

  deliverOrder(order) {
    const orderId = order.uid
    const currentUser = firebase.auth().currentUser;
    const profile = this.state.profile;
    const expoPushToken = order.customer.expoPushNotificationToken;

    if (this.state.code.toUpperCase() !== orderId.substring(10).toUpperCase()) {
      console.log("code =>", this.state.code);
      console.log("orderId.substring(10) =>", orderId.substring(10))
      this.setState({ codeError: true })
      return;
    }

    if (expoPushToken) {
      firebase.firestore().collection('notification').add({
        expoPushNotificationToken: expoPushToken,
        sound: 'default',
        title: 'Order Delivered',
        message: `Great news! Order #${orderId.substring(0, 10).toUpperCase()} has been delivered successfully. Thanks for doing business with us.`
      });
    }

    firebase.firestore().collection('orders').doc(orderId)
      .update({
        status: 'Delivered',
        deliveredAt: new Date().getTime(),
        driver: {
          fullname: profile.fullname,
          uid: currentUser.uid,
          email: profile.email,
          phone: profile.phone,
        },
        driver_uid: currentUser.uid,
      }).then(() => {
        this.handleDeliveryConfirmClose();
        this.setState({ successDelivery: true })
      });
  }

  startPackaging(order) {
    this.setState({ open: true, selectedOrderItems: order.items, selectedOrder: order })
  }

  successDeliveryClose = () => {
    this.setState({ successDelivery: false })
  }

  handleTextChange = (event) => {
    this.setState({ code: event.target.value, codeError: false })
  }

  handleSelectCheckboxItem(order, index) {
    const items = order.items;
    items[index].packed = !items[index].packed;

    const packedLength = items.filter(x => x.packed === true).length;

    if (packedLength === items.length) {
      firebase.firestore().collection('orders').doc(order.uid).update({ items, status: 'Awaiting_Dispatch', awaitingDispatchAt: new Date().getTime() });
    } else {
      firebase.firestore().collection('orders').doc(order.uid).update({ items, status: 'Awaiting_Packaging' });
    }
  }

  saveOrderPackage(order) {
    const items = order.items;

    const packedLength = items.filter(x => x.packed === true).length;

    if (packedLength !== items.length) {
      this.setState({ partialOrderDialogConfirm: true });
    } else {
      this.setState({ partialOrderDialogConfirm: false });
      this.handleClose();
    }

  }

  async confirmPartialOrder() {
    const order = this.state.selectedOrder;
    firebase.firestore().collection('orders').
      doc(order.uid).update({ status: 'Awaiting_Dispatch', awaitingDispatchAt: new Date().getTime() });

    this.setState({ partialOrderDialogConfirm: false });
    this.handleClose();
  }

  handleClose() {
    this.setState({
      open: false, view: false,
      selectedOrderItems: [],
      selectedOrder: {}
    })
  }

  handleViewOrder(order) {
    this.setState({ open: true, view: true, selectedOrderItems: order.items, selectedOrder: order })

  }


  generatePurchaseOrder() {
    this.setState({ mainLoader: true });
    const generatePurchaseOrder = firebase.functions().httpsCallable('generatePurchaseOrder');
    generatePurchaseOrder().then(value => {
      this.setState({ generatePurchaseOrderSuccess: true, mainLoader: false });
    }).catch(reason => {
      this.setState({ mainLoader: false, generatePurchaseOrderFailure: true });
      console.log(reason);
    });
  }

  nothingFound(empty) {
    if (empty && isMobileOnly && !this.state.mainLoader) return <center><img style={{ marginTop: '5%' }} src={require('../assets/img/notfound.png')}></img></center>
    else return <div />
  }

  render() {
    const { classes } = this.props;
    const { value, orders, selectedOrderItems, selectedOrder,
      paymentPendingOrders, paidPendingOrders,
      awaitingPackageOrders, awaitingDispatchedOrders, dispatchedOrders } = this.state;
    const orderItems = chunkify(selectedOrderItems, 2);
    const currentUser = firebase.auth().currentUser;
    return (
      <React.Fragment>
        <br />
        <br />
        {
          isMobileOnly ?
            <Tabs
              centered
              disableRipple
              variant="fullWidth"
              scrollButtons="on"
              value={value}
              onChange={this.handleChange}
              className={classes.tabs}
            >
              <Tab disableFocusRipple disableTouchRipple disableRipple label="Payment Pending" {...a11yProps(0)} />
              <Tab disableFocusRipple disableTouchRipple disableRipple label="Pending" {...a11yProps(1)} />
              <Tab disableFocusRipple disableTouchRipple disableRipple label="Packaging" {...a11yProps(2)} />
              <Tab disableFocusRipple disableTouchRipple disableRipple label="Dispatch" {...a11yProps(3)} />

              {
                // <Tab label="Dispatched" {...a11yProps(4)} />
              }
            </Tabs>
            :
            <Tabs
              centered
              variant="fullWidth"
              scrollButtons="on"
              value={value}
              onChange={this.handleChange}
              aria-label="Vertical tabs example"
              className={classes.tabs}
            >
              {
                this.isAdmin() &&
                <Tab label="Payment Pending" {...a11yProps(0)} />
              }
              <Tab label="Pending" {...a11yProps(1)} />
              <Tab label="Packaging" {...a11yProps(2)} />
              <Tab label="Dispatch" {...a11yProps(3)} />

              {
                <Tab label="Dispatched" {...a11yProps(4)} />
              }
            </Tabs>
        }


        <TabPanel value={value} index={0}>
          {this.nothingFound(paymentPendingOrders.length === 0)}

          {
            isMobileOnly ?
              <Grid container spacing={3}>
                {
                  paymentPendingOrders.map(row => (
                    <Grid item md={12} sm={6} style={{ width: '100%' }}>
                      <Card key={row.uid} style={{ marginTop: '1%' }}>
                        <CardContent>
                          <Typography className={classes.typography} gutterBottom variant="h5" component="h2">
                            #{row.uid.toUpperCase().substring(0, 10)}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Created At:</strong> {new Date(row.created_at).toDateString()}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Customer:</strong> {row.customer.fullname}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Cash back 💴:</strong> ${row.cashSend ? row.cashSend.amountToBeSent : 0}USD
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient:</strong> {row.recipient.full_name}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient Phone:</strong> {row.recipient.phone}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Ship To:</strong> {`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button variant={'contained'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))
                }
              </Grid> :

              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Customer</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell align="left">OrderID</TableCell>

                    <TableCell align="left">Cash back</TableCell>

                    <TableCell align="left">Amount (USD)</TableCell>
                    <TableCell align="left">Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody >
                  {paymentPendingOrders.map(row => (
                    <TableRow key={row.uid}>
                      <TableCell component="th" scope="row">
                        {row.customer.fullname}
                      </TableCell>
                      <TableCell align="left">{new Date(row.created_at).toDateString()}</TableCell>
                      <TableCell align="left">{row.uid.substring(0, 10).toUpperCase()}</TableCell>

                      <TableCell align="left">{`${row.cashSend ? row.cashSend.amountToBeSent : 0}USD`}</TableCell>


                      <TableCell align="left">{row.totalPriceBreakdown.total}</TableCell>
                      <TableCell align="left">
                        <Button variant={'outlined'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
          }
        </TabPanel>


        <TabPanel value={value} index={1}>
          {this.nothingFound(paidPendingOrders.length === 0)}

          {
            isMobileOnly ?
              <Grid container spacing={3}>
                {

                  paidPendingOrders.map(row => (
                    <Grid item md={12} sm={6} style={{ width: '100%' }}>

                      <Card key={row.uid} style={{ marginTop: '1%' }}>
                        <CardContent>
                          <Typography className={classes.typography} gutterBottom variant="h5" component="h2">
                            #{row.uid.toUpperCase().substring(0, 10)}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Created At:</strong> {new Date(row.created_at).toDateString()}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Customer:</strong> {row.customer.fullname}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Cash back 💴:</strong> ${row.cashSend ? row.cashSend.amountToBeSent ||0 : 0}USD
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient:</strong> {row.recipient.full_name}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient Phone:</strong> {row.recipient.phone}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Ship To:</strong> {`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button variant="contained" size="small" color="secondary" onClick={() => this.pickOrder(row)}>
                            Pick Order
                          </Button>
                          <Button variant={'outlined'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}

              </Grid> :

              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Customer</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell align="left">OrderID</TableCell>
                    <TableCell align="left">Cash back</TableCell>
                    <TableCell align="left">Amount (USD)</TableCell>
                    <TableCell align="left">Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody >
                  {paidPendingOrders.map(row => (
                    <TableRow key={row.uid}>
                      <TableCell component="th" scope="row">
                        {row.customer.fullname}
                      </TableCell>
                      <TableCell align="left">{new Date(row.created_at).toDateString()}</TableCell>
                      <TableCell align="left">{row.uid.substring(0, 10).toUpperCase()}</TableCell>
                      <TableCell align="left">{`${row.cashSend ? row.cashSend.amountToBeSent : 0}USD`}</TableCell>
                      <TableCell align="left">{row.totalPriceBreakdown.total}</TableCell>
                      <TableCell align="left">
                        <Button variant="contained" color="secondary" onClick={() => this.pickOrder(row)}>Pick</Button>
                        <Button variant={'outlined'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
          }
        </TabPanel>
        <TabPanel value={value} index={2}>
          {this.nothingFound(awaitingPackageOrders.length === 0)}

          {
            isMobileOnly ?
              <Grid container spacing={3}>
                {
                  awaitingPackageOrders.map(row => (
                    <Grid item md={12} sm={6} style={{ width: '100%' }}>

                      <Card style={{ marginTop: '1%' }}>
                        <CardContent>
                          <Typography className={classes.typography} gutterBottom variant="h5" component="h2">
                            #{row.uid.toUpperCase().substring(0, 10)}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Created At:</strong> {new Date(row.created_at).toDateString()}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Customer:</strong> {row.customer.fullname}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Cash back 💴:</strong> ${row.cashSend ? row.cashSend.amountToBeSent : 0}USD
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient:</strong> {row.recipient.full_name}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient Phone:</strong> {row.recipient.phone}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Ship To:</strong> {`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button variant="contained" size="small" color="secondary" onClick={() => this.startPackaging(row)}>
                            {row.items.find(item => item.packed === true) ? 'Resume Packing' : 'Start Packing'}
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
              </Grid> :
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Customer</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell align="left">OrderID</TableCell>
                    <TableCell align="left">Cash back</TableCell>
                    <TableCell align="left">Amount (USD)</TableCell>
                    <TableCell align="left">Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody >
                  {awaitingPackageOrders.map(row => (
                    <TableRow key={row.uid}>
                      <TableCell component="th" scope="row">
                        {row.customer.fullname}
                      </TableCell>
                      <TableCell align="left">{new Date(row.created_at).toDateString()}</TableCell>
                      <TableCell align="left">{row.uid.substring(0, 10).toUpperCase()}</TableCell>
                      <TableCell align="left">{`${row.cashSend ? row.cashSend.amountToBeSent : 0}USD`}</TableCell>
                      <TableCell align="left">{row.totalPriceBreakdown.total}</TableCell>
                      <TableCell align="left"><Button variant="contained" color="secondary" onClick={() => this.startPackaging(row)} >{row.items.find(item => item.packed === true) ? 'Resume Packing' : 'Start Packing'}</Button></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
          }
        </TabPanel>
        <TabPanel value={value} index={3}>
          {this.nothingFound(awaitingDispatchedOrders.length === 0)}

          {
            isMobileOnly ?
              <Grid container spacing={3}>
                {
                  awaitingDispatchedOrders.map(row => (
                    <Grid item md={12} sm={6} style={{ width: '100%' }} md={12}>

                      <Card style={{ marginTop: '1%' }}>
                        <CardContent>
                          <Typography className={classes.typography} gutterBottom variant="h5" component="h2">
                            #{row.uid.toUpperCase().substring(0, 10)}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Created At:</strong> {new Date(row.created_at).toDateString()}
                          </Typography>

                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Customer:</strong> {row.customer.fullname}
                          </Typography>

                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Cash back 💴:</strong> ${row.cashSend ? row.cashSend.amountToBeSent : 0}USD
                          </Typography>

                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient:</strong> {row.recipient.full_name}
                          </Typography>

                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient Phone:</strong> {row.recipient.phone}
                          </Typography>

                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Ship To:</strong> {`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button variant="contained" size="small" color="secondary" onClick={() => this.dispatchOrder(row.uid)}>
                            Dispatch
                          </Button>
                          <Button variant={'outlined'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
              </Grid> :
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Created At</TableCell>
                    <TableCell align="left">OrderID</TableCell>

                    <TableCell align="left">Cash back</TableCell>

                    <TableCell align="left">Ship To</TableCell>
                    <TableCell align="left">Amount (USD)</TableCell>
                    <TableCell align="left">Action</TableCell>

                  </TableRow>
                </TableHead>
                <TableBody >
                  {awaitingDispatchedOrders.map(row => (
                    <TableRow key={row.uid}>
                      <TableCell align="left">{new Date(row.created_at).toDateString()}</TableCell>
                      <TableCell align="left">{row.uid.substring(0, 10).toUpperCase()}</TableCell>

                      <TableCell align="left">{`${row.cashSend ? row.cashSend.amountToBeSent : 0}USD`}</TableCell>


                      <TableCell align="left">{`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}</TableCell>
                      <TableCell align="left">{row.totalPriceBreakdown.total}</TableCell>
                      <TableCell align="left"><Button variant="contained" color="secondary" onClick={() => this.dispatchOrder(row.uid)}>Dispatch</Button></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
          }
        </TabPanel>
        <TabPanel value={value} index={4}>
          {this.nothingFound(dispatchedOrders.length === 0)}

          {
            isMobileOnly ?
              <Grid container spacing={3}>
                {
                  dispatchedOrders.map(row => (
                    <Grid item md={12} sm={6} style={{ width: '100%' }} >

                      <Card style={{ marginTop: '1%' }}>
                        <CardContent>
                          <Typography className={classes.typography} gutterBottom variant="h5" component="h2">
                            #{row.uid.toUpperCase().substring(0, 10)}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Created At:</strong> {new Date(row.created_at).toDateString()}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p">
                            <strong>Cash back 💴:</strong> ${row.cashSend ? row.cashSend.amountToBeSent : 0}USD
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient:</strong> {row.recipient.full_name}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Recipient Phone:</strong> {row.recipient.phone}
                          </Typography>
                          <Typography className={classes.typography} variant="body2" color="textSecondary" component="p" style={{ marginTop: '2%' }}>
                            <strong>Ship To:</strong> {`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <Button
                            size="small"
                            color="primary"
                            href={`tel:${row.recipient.phone}`}
                            variant={'outlined'}
                            startIcon={<CallIcon />}
                          >
                            Call
                          </Button>
                          <Button variant="contained" size="small" color="secondary" onClick={() => this.handleDeliveryConfirmOpen(row)}>Deliver</Button>
                          <Button variant={'outlined'} variant={'outlined'} size="small" color="primary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
              </Grid> :
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    {
                      /**
                       * <TableCell>Created At</TableCell>
                       */
                    }

                    <TableCell align="left">OrderID</TableCell>
                    <TableCell align="left">Cash back</TableCell>
                    <TableCell align="left">Recipient</TableCell>
                    <TableCell align="left">Recipient Phone</TableCell>
                    <TableCell align="left">Ship To</TableCell>
                    {
                      /**
                       * <TableCell align="left">Amount (USD)</TableCell>
                       */
                    }
                    <TableCell align="left">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  {dispatchedOrders.map(row => (
                    <TableRow key={row.uid}>
                      {
                        /**
                         * <TableCell align="left">{new Date(row.created_at).toDateString()}</TableCell>
                         */
                      }
                      <TableCell align="left">{row.uid.substring(0, 10).toUpperCase()}</TableCell>
                      <TableCell align="left">{`${row.cashSend ? row.cashSend.amountToBeSent : 0}USD`}</TableCell>
                      <TableCell align="left">{row.recipient.full_name}</TableCell>
                      <TableCell align="left"><Button variant="contained" color="primary" href={`tel:${row.recipient.phone}`}>{row.recipient.phone}</Button></TableCell>
                      <TableCell align="left">{`${row.recipient.address_1} ${row.recipient.address_2} ${row.recipient.town}`}</TableCell>
                      {
                        /**
                         * <TableCell align="left">{row.totalPriceBreakdown.total}</TableCell>
                         */
                      }

                      <TableCell align="left">
                        <Button variant="text" color="secondary" onClick={() => this.handleViewOrder(row)}>View Order</Button>
                        <Button style={{ marginLeft: '2%' }} variant="contained" color="secondary" onClick={() => this.handleDeliveryConfirmOpen(row)}>Delivered</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
          }
        </TabPanel>
        {
          this.state.value === 1 && this.isAdminOrSupervisor() &&
          <Fab
            variant="extended"
            size="small"
            color="secondary"
            aria-label="add"
            style={
              {
                margin: 0,
                top: 'auto',
                right: "auto",
                bottom: 30,
                right: 20,
                position: 'fixed',
              }
            }
            onClick={this.generatePurchaseOrder.bind(this)}
          >
            Purchase Order
          </Fab>
        }


        <Dialog fullScreen open={this.state.open} onClose={this.handleClose.bind(this)}>
          <AppBar style={{ position: 'relative' }} >
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={this.handleClose.bind(this)} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ margin: '0 auto' }}>
                {`#${selectedOrder.uid ? selectedOrder.uid.substring(0, 10).toUpperCase() : ""} Checklist`}
              </Typography>
              {
                !this.state.view &&
                <IconButton edge="start" color="inherit" onClick={() => this.saveOrderPackage(selectedOrder)} aria-label="Save">
                  <SaveIcon />
                </IconButton>
              }
            </Toolbar>
          </AppBar>
          <Grid container>
            <div style={{ width: '100%' }}>
              <Grid container>
                <br />
                <br />
                <Grid item sm={6} md={6}>
                  <List>
                    {orderItems[0].map((orderItem, index) => {
                      const labelId = `checkbox-list-label-${index}`;
                      return (
                        <ListItem key={index} role={undefined} dense button>
                          <ListItemIcon>
                            <Checkbox
                              disabled={this.state.view}
                              edge="start"
                              tabIndex={-1}
                              inputProps={{ 'aria-labelledby': labelId }}
                              onChange={() => this.handleSelectCheckboxItem(selectedOrder, index)}
                              checked={orderItem.packed}
                            />
                          </ListItemIcon>
                          <ListItemAvatar>
                            <img style={{ height: 50 }} src={orderItem.product.image} />
                          </ListItemAvatar>
                          <ListItemText style={{ width: '35%' }} id={labelId} primary={`${orderItem.product.name} ${orderItem.product.quantity}`} />
                          <ListItemText primary={`X ${orderItem.qty}`} />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>

                <Grid sm={6} md={6}>
                  <List>
                    {orderItems[1].map((orderItem, index) => {
                      const labelId = `checkbox-list-label-${index}`;
                      return (
                        <ListItem key={index} role={undefined} dense button>
                          <ListItemIcon>
                            <Checkbox
                              disabled={this.state.view}
                              edge="start"
                              tabIndex={-1}
                              inputProps={{ 'aria-labelledby': labelId }}
                              onChange={() => this.handleSelectCheckboxItem(selectedOrder, index + (selectedOrderItems.length % 2 == 0 ? orderItems[1].length : (orderItems[1].length + 1)))}
                              checked={orderItem.packed}
                            />
                          </ListItemIcon>
                          <ListItemAvatar>
                            <img style={{ height: 50 }} src={orderItem.product.image} />
                          </ListItemAvatar>
                          <ListItemText style={{ width: '35%' }} id={labelId} primary={`${orderItem.product.name} ${orderItem.product.quantity}`} />
                          <ListItemText primary={`X ${orderItem.qty}`} />
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>

              </Grid>
            </div>
          </Grid>
        </Dialog>

        <Dialog open={this.state.openDeliveryConfirm} onClose={this.handleDeliveryConfirmClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Delivery Verification</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To confirm delivery, please enter the 10 character verification code that has been sent to the recipient.
            </DialogContentText>
            <TextField
              margin="dense"
              id="code"
              label="Secrete Code"
              type="text"
              fullWidth
              onChange={this.handleTextChange}
              value={this.state.code}
              error={this.state.codeError}
              helperText={this.state.codeError ? "Invalid verification code. Please try again." : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeliveryConfirmClose} color="primary">
              Cancel
            </Button>
            <Button onClick={() => this.deliverOrder(this.state.selectedOrder)} color="primary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog open={this.state.riskyDialogOpen} onClose={this.handleRiskyDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">High Risk Order Alert</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: 'red' }}>
              This order been considered to be of high risk. Due to its uncertainity, the system will not allow it to be processed. Please consult the administrator immediately.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleRiskyDialogClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.noPurchaseOrderDialog} onClose={() => this.setState({ noPurchaseOrderDialog: false })} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">No Purchase Order</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: 'red' }}>
              There is no purchase order associated with this order. A purchase order might need to be generated please consult admin if you need more information.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ noPurchaseOrderDialog: false })} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog open={this.state.partialOrderDialogConfirm} onClose={() => this.setState({ partialOrderDialogConfirm: false })} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Confirm Partial Order</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure? You are about to move forward an incomplete order.
              If the action is unintended please press cancel, otherwise confirm to proceed.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ partialOrderDialogConfirm: false })} color="primary">
              Cancel
            </Button>
            <Button color="primary" onClick={this.confirmPartialOrder.bind(this)}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>


        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.successDelivery}
          autoHideDuration={6000}
          onClose={this.successDeliveryClose}>
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.successDeliveryClose}
            severity="success"
          >
            Order successfully delivered
          </MuiAlert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.generatePurchaseOrderSuccess}
          autoHideDuration={6000}
          onClose={() => this.setState({ generatePurchaseOrderSuccess: false })}>
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={() => this.setState({ generatePurchaseOrderSuccess: false })}
            severity="success"
          >
            Purchase Order generation successfully requested, an email will be sent shortly if there are any pending orders.
          </MuiAlert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.generatePurchaseOrderFailure}
          autoHideDuration={6000}
          onClose={() => this.setState({ generatePurchaseOrderFailure: false })}>
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={() => this.setState({ generatePurchaseOrderFailure: false })}
            severity="error"
          >
            An error occurred, check your network and try again.
          </MuiAlert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.pickOrderSuccess}
          autoHideDuration={6000}
          onClose={() => this.setState({ pickOrderSuccess: false })}>
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={() => this.setState({ pickOrderSuccess: false })}
            severity="success"
          >
            Order successfully picked for packaging
          </MuiAlert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={this.state.pickOrderFailure}
          autoHideDuration={6000}
          onClose={() => this.setState({ pickOrderFailure: false })}>
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={() => this.setState({ pickOrderFailure: false })}
            severity="error"
          >
            An error occurred, check your network and try again.
          </MuiAlert>
        </Snackbar>

        <Backdrop open={this.state.mainLoader} style={{
          zIndex: 200,
          color: '#fff'
        }}>
          <CircularProgress color="inherit" />
        </Backdrop>

      </React.Fragment>
    );
  }

}

export default withStyles(styles)(Workspace);